<template>
  <div
    class="d-inline-block text-right"
  >
    <div
      v-if="$vuetify.display.smAndUp"
    >
      <user-nickname-picture
        v-if="user"
        :user="user"
      />
    </div>
  </div>
</template>

<script>
import UserNicknamePicture from '@/components/UserNicknamePicture.vue';
import { useUserStore } from '@/store/user.module';

export default {
  name: 'UserInfo',
  components: {
    UserNicknamePicture,
  },
  computed: {
    user() {
      const userStore = useUserStore();
      return userStore.currentUser;
    },
  },
};
</script>
